import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { separadoresService } from '../services/api';
import SeparadorCard from '../components/SeparadorCard';
import GraficoSeparador from '../components/GraficoSeparador';

const COLS = ['Separador / Pozo', 'Estado', 'Tiempo acumulado', 'Caudal gas', 'Caudal petróleo', 'Presión', 'Temp'];

function fmt(v, dec=1) {
  return v != null ? Number(v).toFixed(dec) : '—';
}

async function descargarReporteDiario(sepId, fecha) {
  const token = localStorage.getItem('token');
  const r = await fetch(`/api/separadores/${sepId}/reporte-diario?fecha=${fecha}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  if (!r.ok) { alert('Error generando reporte'); return; }
  const blob = await r.blob();
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement('a');
  a.href     = url;
  a.download = `reporte_${sepId}_${fecha}.pdf`;
  a.click();
  URL.revokeObjectURL(url);
}

async function descargarReporteEnsayo(sepId, pozo, inicio, fin) {
  const token = localStorage.getItem('token');
  const params = new URLSearchParams({ inicio: inicio||'', pozo: pozo||'' });
  if (fin) params.set('fin', fin);
  const r = await fetch(`/api/separadores/${sepId}/reporte-ensayo?${params}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  if (!r.ok) { alert('Error generando reporte de ensayo'); return; }
  const blob = await r.blob();
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement('a');
  a.href     = url;
  a.download = `ensayo_${sepId}_${(pozo||'').replace(/\s/g,'_')}_${(inicio||'').slice(0,10)}.pdf`;
  a.click();
  URL.revokeObjectURL(url);
}

async function descargarEnsayo(sepId, pozo, inicio, fin) {
  const token = localStorage.getItem('token');
  const params = new URLSearchParams({ inicio: inicio||'', fin: fin||'', pozo: pozo||'' });
  const r = await fetch(`/api/separadores/${sepId}/ensayo/pdf-tendencias?${params}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  if (!r.ok) { alert('Error generando informe'); return; }
  const blob = await r.blob();
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement('a');
  a.href     = url;
  a.download = `ensayo_${sepId}_${pozo}_${(inicio||'').slice(0,10)}.pdf`;
  a.click();
  URL.revokeObjectURL(url);
}

async function descargarPDF(sepId) {
  const token = localStorage.getItem('token');
  const r = await fetch(`/api/separadores/${sepId}/pdf`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  if (!r.ok) { alert('Error generando PDF'); return; }
  const blob = await r.blob();
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement('a');
  a.href     = url;
  a.download = `informe_${sepId}_${new Date().toISOString().slice(0,10)}.pdf`;
  a.click();
  URL.revokeObjectURL(url);
}

function HistorialPanel({ sep }) {
  const [histExtra, setHistExtra] = useState(null);
  const [cargando, setCargando]   = useState(false);

  if (!sep) return null;
  const hist = histExtra || sep.historial || [];

  const cargarMas = async () => {
    setCargando(true);
    try {
      const token = localStorage.getItem('token');
      const r = await fetch(`/api/separadores/${sep.id}/historial`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const d = await r.json();
      setHistExtra(d.historial || []);
    } catch(e) { console.error(e); }
    finally { setCargando(false); }
  };

  return (
    <div style={{
      background:'#ffffff', borderTop:'1px solid #e0e0e0',
      padding:'14px 20px', flexShrink:0, maxHeight:'280px', overflowY:'auto'
    }}>
      <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'10px'}}>
        <span style={{fontSize:'12px', fontWeight:'600', color:'#1a1a1a'}}>
          {sep.nombre} — {sep.pozo}
        </span>
        <div style={{display:'flex', gap:'6px'}}>
          <button
            onClick={() => {
              const hoy = new Date().toISOString().slice(0,10);
              descargarReporteDiario(sep.id, hoy);
            }}
            style={{
              padding:'4px 10px', borderRadius:'6px',
              border:'1px solid #e0e0e0', background:'#f5f5f5',
              fontSize:'11px', color:'#6b6b6b', cursor:'pointer'
            }}>Reporte diario</button>
          <button
            onClick={async () => {
              const token = localStorage.getItem('token');
              const r = await fetch(`/api/separadores/${sep.id}/pdf-tendencias`, {
                headers: { Authorization: `Bearer ${token}` }
              });
              const blob = await r.blob();
              const url  = URL.createObjectURL(blob);
              const a    = document.createElement('a');
              a.href     = url;
              a.download = `tendencias_${sep.id}_${new Date().toISOString().slice(0,10)}.pdf`;
              a.click();
              URL.revokeObjectURL(url);
            }}
            style={{
              padding:'4px 10px', borderRadius:'6px',
              border:'1px solid #e0e0e0', background:'#f5f5f5',
              fontSize:'11px', color:'#6b6b6b', cursor:'pointer'
            }}>Tendencias</button>
          <button
            onClick={() => descargarPDF(sep.id)}
            style={{
              padding:'4px 10px', borderRadius:'6px',
              border:'1px solid #c0c0c0',
              background:'#f0f0f0', fontSize:'11px', color:'#1a1a1a', cursor:'pointer'
            }}>Informe ensayo</button>
        </div>
      </div>
      <table style={{width:'100%', borderCollapse:'collapse', fontSize:'11px'}}>
        <thead>
          <tr>
            {['Pozo','Inicio','Fin','Duración','Estado'].map(h => (
              <th key={h} style={{
                textAlign:'left', color:'#a0a0a0', fontWeight:'400',
                padding:'4px 8px', borderBottom:'1px solid #e0e0e0',
                textTransform:'uppercase', letterSpacing:'0.06em', fontSize:'9px'
              }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {hist.length === 0 && (
            <tr><td colSpan={5} style={{color:'#a0a0a0', padding:'12px 8px', textAlign:'center'}}>
              Sin historial registrado
            </td></tr>
          )}
          {hist.map((h, i) => {
            const dur = h.display || (h.duracion_seg ? `${Math.floor(h.duracion_seg/3600)}h ${String(Math.floor((h.duracion_seg%3600)/60)).padStart(2,"0")}m` : '—');
            const esCurso = h.estado === 'en_curso';
            // Detectar si el "pozo" es un código de tiempo muerto (1-6)
            const CODIGOS_TM = {'1':'Stand By cliente','2':'Stand By falla','3':'Falta recurso SGA','4':'Factor climático','5':'DTM','6':'Espera ROC'};
            const esTM = h.pozo && CODIGOS_TM[h.pozo.trim()];
            const pozoDisplay = esTM ? `⏸ ${CODIGOS_TM[h.pozo.trim()]}` : h.pozo;
            return (
              <tr key={i}>
                <td style={{padding:'5px 8px', color: esTM ? '#9333ea' : '#2563eb', fontFamily:'monospace', borderBottom:'1px solid #e0e0e0'}}>{pozoDisplay}</td>
                <td style={{padding:'5px 8px', color:'#6b6b6b', borderBottom:'1px solid #e0e0e0'}}>{h.inicio ? h.inicio.slice(5,16) : '—'}</td>
                <td style={{padding:'5px 8px', color:'#6b6b6b', borderBottom:'1px solid #e0e0e0'}}>{h.fin ? h.fin.slice(5,16) : '—'}</td>
                <td style={{padding:'5px 8px', fontFamily:'monospace', fontWeight:'600', color: esTM ? '#9333ea' : esCurso ? '#16a34a' : '#1a1a1a', borderBottom:'1px solid #e0e0e0'}}>{h.display || '—'}</td>
                <td style={{padding:'5px 8px', borderBottom:'1px solid #e0e0e0'}}>
                  <div style={{display:'flex', alignItems:'center', gap:'6px'}}>
                    {esTM ? (
                      <span style={{
                        padding:'2px 7px', borderRadius:'20px', fontSize:'9px', fontWeight:'600',
                        background:'#faf5ff', color:'#9333ea',
                        border:'1px solid rgba(147,51,234,0.2)'
                      }}>⏸ tiempo muerto</span>
                    ) : (
                      <>
                        <span style={{
                          padding:'2px 7px', borderRadius:'20px', fontSize:'9px', fontWeight:'600',
                          background: esCurso ? '#f0fdf4' : '#f0f0f0',
                          color: esCurso ? '#16a34a' : '#6b6b6b',
                          border: `1px solid ${esCurso ? 'rgba(22,163,74,0.2)' : 'transparent'}`
                        }}>
                          {esCurso ? '● en curso' : '✓ fin'}
                        </span>
                        <button
                          onClick={() => descargarReporteEnsayo(sep.id, h.pozo, h.inicio, h.fin)}
                          style={{
                            padding:'2px 7px', borderRadius:'5px',
                            border:'1px solid #c0c0c0', background:'#f0f0f0',
                            fontSize:'10px', color:'#1a1a1a', cursor:'pointer', fontWeight:'500'
                          }}>Ensayo</button>
                        <button
                          onClick={() => descargarEnsayo(sep.id, h.pozo, h.inicio, h.fin)}
                          style={{
                            padding:'2px 7px', borderRadius:'5px',
                            border:'1px solid #e0e0e0', background:'#f5f5f5',
                            fontSize:'10px', color:'#6b6b6b', cursor:'pointer'
                          }}>Tendencias</button>
                        <button
                          onClick={() => {
                            const fecha = (h.inicio || '').slice(0,10);
                            if (fecha) descargarReporteDiario(sep.id, fecha);
                          }}
                          style={{
                            padding:'2px 7px', borderRadius:'5px',
                            border:'1px solid #e0e0e0', background:'#f5f5f5',
                            fontSize:'10px', color:'#6b6b6b', cursor:'pointer'
                          }}>Reporte</button>
                      </>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {!histExtra && hist.length > 0 && (
        <div style={{textAlign:'center', marginTop:'8px'}}>
          <button
            onClick={cargarMas}
            disabled={cargando}
            style={{
              padding:'4px 12px', borderRadius:'6px',
              border:'1px solid #e0e0e0', background:'#f5f5f5',
              fontSize:'11px', color:'#6b6b6b', cursor:'pointer'
            }}>{cargando ? 'Cargando...' : 'Ver historial completo'}</button>
        </div>
      )}
    </div>
  );
}

export default function Dashboard() {
  const { usuario, logout }   = useAuth();
  const [data, setData]       = useState(null);
  const [selected, setSelected] = useState(null);
  const [error, setError]     = useState('');
  const [lastUpdate, setLastUpdate] = useState('');
  const [grafico, setGrafico]       = useState(null);
  const [paeStatus, setPaeStatus]   = useState({});

  const fetchPaeStatus = async () => {
    try {
      const token = localStorage.getItem('token');
      const r = await fetch('/api/separadores/pae-toggle', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPaeStatus(await r.json());
    } catch(e) { console.error(e); }
  };

  const togglePae = async (sepId) => {
    const token = localStorage.getItem('token');
    const r = await fetch(`/api/separadores/pae-toggle/${sepId}`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` }
    });
    if (r.ok) fetchPaeStatus();
  };

  const fetchData = useCallback(async () => {
    try {
      const { data: d } = await separadoresService.getAll();
      setData(d);
      setLastUpdate(new Date().toLocaleTimeString('es-AR'));
      setError('');
    } catch {
      setError('Error conectando al servidor');
    }
  }, []);

  useEffect(() => {
    fetchData();
    fetchPaeStatus();
    const iv = setInterval(fetchData, 15000);
    const iv2 = setInterval(fetchPaeStatus, 30000);
    return () => { clearInterval(iv); clearInterval(iv2); };
  }, [fetchData]);

  const seps = data ? Object.values(data.separadores) : [];
  const activos  = seps.filter(s => s.corriendo).length;
  const offline  = seps.filter(s => !s.activo).length;
  const enTM     = seps.filter(s => s.codigo_tm).length;
  const selectedSep = selected ? data?.separadores?.[selected] : null;

  return (
    <div style={{
      display:'flex', flexDirection:'column', height:'100vh',
      background:'#f5f5f5', fontFamily:'Inter,-apple-system,sans-serif', overflow:'hidden'
    }}>
      {/* TOPBAR */}
      <div style={{
        background:'#ffffff', borderBottom:'1px solid #e0e0e0',
        padding:'0 20px', height:'48px',
        display:'flex', alignItems:'center', justifyContent:'space-between', flexShrink:0,
        boxShadow:'0 1px 2px rgba(0,0,0,0.04)'
      }}>
        <div style={{display:'flex', alignItems:'center', gap:'10px'}}>
          <img src='/logo192.png' alt='Rocket Tech' style={{width:'32px',height:'32px',borderRadius:'50%'}}/>
          <span style={{fontSize:'14px', fontWeight:'600', color:'#1a1a1a'}}>SepManager</span>
          <span style={{fontSize:'11px', color:'#a0a0a0'}}>Performance SRL</span>
        </div>
        <div style={{display:'flex', alignItems:'center', gap:'16px'}}>
          {lastUpdate && (
            <span style={{fontSize:'11px', color:'#a0a0a0', fontFamily:'monospace'}}>
              act. {lastUpdate}
            </span>
          )}
          <div style={{
            display:'flex', alignItems:'center', gap:'5px', padding:'4px 10px',
            borderRadius:'20px', background:'#f0fdf4',
            border:'1px solid rgba(22,163,74,0.25)', fontSize:'11px', color:'#16a34a'
          }}>
            <div style={{width:'6px', height:'6px', borderRadius:'50%', background:'#22c55e', animation:'blink 2s infinite'}}/>
            MQTT conectado
          </div>
          <div style={{display:'flex', alignItems:'center', gap:'8px'}}>
            <div style={{
              width:'26px', height:'26px', borderRadius:'50%',
              background:'#f0f0f0', border:'1px solid #d0d0d0',
              display:'flex', alignItems:'center', justifyContent:'center',
              fontSize:'10px', color:'#1a1a1a', fontWeight:'600'
            }}>
              {usuario?.nombre?.split(' ').map(n=>n[0]).join('').slice(0,2)}
            </div>
            <div>
              <div style={{fontSize:'11px', color:'#1a1a1a'}}>{usuario?.nombre}</div>
              <div style={{fontSize:'10px', color:'#a0a0a0'}}>{usuario?.rol}</div>
            </div>
            <button onClick={logout} style={{
              padding:'4px 8px', borderRadius:'6px',
              border:'1px solid #e0e0e0', background:'transparent',
              color:'#6b6b6b', fontSize:'11px', cursor:'pointer'
            }}>Salir</button>
          </div>
        </div>
      </div>

      {/* SUBHEADER */}
      <div style={{
        background:'#ffffff', borderBottom:'1px solid #e0e0e0',
        padding:'8px 20px', display:'flex', alignItems:'center',
        justifyContent:'space-between', flexShrink:0
      }}>
        <div style={{display:'flex', alignItems:'center', gap:'12px'}}>
          <span style={{fontSize:'13px', fontWeight:'600', color:'#1a1a1a'}}>
            Separadores — tiempo real
          </span>
          <span style={{
            padding:'3px 9px', borderRadius:'20px', fontSize:'10px', fontWeight:'600',
            background:'#f0fdf4', color:'#16a34a', border:'1px solid rgba(22,163,74,0.2)'
          }}>{activos} en ensayo</span>
          {enTM > 0 && (
            <span style={{
              padding:'3px 9px', borderRadius:'20px', fontSize:'10px', fontWeight:'600',
              background:'#faf5ff', color:'#9333ea', border:'1px solid rgba(147,51,234,0.2)'
            }}>{enTM} tiempo muerto</span>
          )}
          {offline > 0 && (
            <span style={{
              padding:'3px 9px', borderRadius:'20px', fontSize:'10px', fontWeight:'600',
              background:'#fef2f2', color:'#dc2626', border:'1px solid rgba(220,38,38,0.2)'
            }}>{offline} offline</span>
          )}
        </div>
        <div style={{display:'flex', gap:'6px'}}>
          <button onClick={() => window.location.href = '/estados'} style={{
            display:'flex', alignItems:'center', gap:'5px', padding:'5px 10px',
            borderRadius:'6px', border:'1px solid rgba(147,51,234,0.3)', background:'#faf5ff',
            fontSize:'11px', color:'#7c3aed', cursor:'pointer', fontWeight:'600'
          }}>📋 Estados</button>
          <button style={{
            display:'flex', alignItems:'center', gap:'5px', padding:'5px 10px',
            borderRadius:'6px', border:'1px solid #e0e0e0', background:'#f5f5f5',
            fontSize:'11px', color:'#6b6b6b', cursor:'pointer'
          }}>⬇ Exportar</button>
          <button
            onClick={async () => {
              const token = localStorage.getItem('token');
              const r = await fetch('/api/separadores/informe/conectividad', {
                headers: { Authorization: `Bearer ${token}` }
              });
              const blob = await r.blob();
              const url  = URL.createObjectURL(blob);
              const a    = document.createElement('a');
              a.href     = url;
              a.download = `informe_conectividad_${new Date().toISOString().slice(0,7)}.pdf`;
              a.click();
              URL.revokeObjectURL(url);
            }}
            style={{
              display:'flex', alignItems:'center', gap:'5px', padding:'5px 10px',
              borderRadius:'6px', border:'1px solid #c0c0c0',
              background:'#f0f0f0', fontSize:'11px', color:'#1a1a1a', cursor:'pointer'
            }}>📄 Informe PDF</button>
        </div>
      </div>

      {/* GRID */}
      <div style={{flex:1, overflowY:'auto', padding:'14px 16px'}}>
        {error && (
          <div style={{
            background:'#fef2f2', border:'1px solid #ef4444', borderRadius:'8px',
            padding:'10px 14px', color:'#dc2626', fontSize:'12px', marginBottom:'12px'
          }}>{error}</div>
        )}

        {/* Header columnas */}
        <div style={{
          display:'grid',
          gridTemplateColumns:'180px 130px 150px 1fr 1fr 1fr 1fr 1fr 70px',
          gap:0, padding:'0 16px 6px',
          fontSize:'9px', color:'#a0a0a0', textTransform:'uppercase', letterSpacing:'0.08em'
        }}>
          <div>Separador / Pozo</div>
          <div style={{paddingLeft:'12px'}}>Estado</div>
          <div style={{paddingLeft:'12px'}}>Tiempo</div>
          <div style={{paddingLeft:'12px'}}>Caudal gas</div>
          <div style={{paddingLeft:'12px'}}>Caudal petróleo</div>
          <div style={{paddingLeft:'12px'}}>Caudal agua</div>
          <div style={{paddingLeft:'12px'}}>Presión gas</div>
          <div style={{paddingLeft:'12px'}}>Temperatura</div>
          <div/>
        </div>

        {/* Filas */}
        {seps.map(sep => {
          const corriendo = sep.corriendo;
          const activo    = sep.activo;
          const tiempoMuerto = sep.codigo_tm;  // "1"-"6" o null
          const descTM       = sep.desc_tm;     // descripción del código
          const stColor   = tiempoMuerto ? '#9333ea' : corriendo ? '#16a34a' : activo ? '#d97706' : '#a0a0a0';
          const datos     = sep.datos || {};
          const isSel     = selected === sep.id;

          return (
            <div
              key={sep.id}
              onClick={() => setSelected(isSel ? null : sep.id)}
              style={{
                display:'grid',
                gridTemplateColumns:'180px 130px 150px 1fr 1fr 1fr 1fr 1fr 70px',
                alignItems:'center', marginBottom:'6px',
                background: isSel ? '#f0f0f0' : '#ffffff',
                border:`1px solid ${isSel ? '#c0c0c0' : '#e0e0e0'}`,
                borderLeft:`3px solid ${stColor}`,
                borderRadius:'10px', cursor:'pointer',
                opacity: activo ? 1 : 0.5,
                transition:'border-color 0.15s',
                boxShadow:'0 1px 2px rgba(0,0,0,0.03)'
              }}
            >
              {/* Identidad */}
              <div style={{padding:'12px 12px 12px 14px', borderRight:'1px solid #e0e0e0'}}>
                <div style={{fontSize:'13px', fontWeight:'600', color:'#1a1a1a'}}>{sep.nombre}</div>
                <div style={{fontSize:'9px', color:'#a0a0a0', fontFamily:'monospace', marginTop:'1px'}}>{sep.deveui}</div>
                <div style={{fontSize:'11px', color: tiempoMuerto ? '#9333ea' : '#2563eb', fontFamily:'monospace', marginTop:'4px'}}>
                  {tiempoMuerto ? `⏸ ${descTM}` : (sep.pozo || '—')}
                </div>
              </div>

              {/* Estado */}
              <div style={{padding:'0 12px', borderRight:'1px solid #e0e0e0'}}>
                <div style={{
                  display:'inline-flex', alignItems:'center', gap:'5px',
                  padding:'4px 8px', borderRadius:'20px',
                  background: tiempoMuerto ? '#faf5ff' : corriendo ? '#f0fdf4' : activo ? '#fffbeb' : '#f5f5f5',
                  border:`1px solid ${stColor}22`,
                  fontSize:'10px', fontWeight:'600', color:stColor
                }}>
                  <div style={{
                    width:'5px', height:'5px', borderRadius:'50%', background:stColor,
                    animation: corriendo ? 'blink 1.5s infinite' : 'none'
                  }}/>
                  {tiempoMuerto ? `Cód ${tiempoMuerto}` : corriendo ? 'En ensayo' : activo ? 'Bypass' : 'Sin señal'}
                </div>
              </div>

              {/* Timer */}
              <div style={{padding:'0 12px', borderRight:'1px solid #e0e0e0'}}>
                <div style={{
                  fontSize:'18px', fontWeight:'700', fontFamily:'monospace',
                  letterSpacing:'0.02em', color:stColor
                }}>
                  {sep.display || '--h --m --s'}
                </div>
                {sep.inicio_ensayo && (
                  <div style={{fontSize:'9px', color:'#a0a0a0', marginTop:'2px'}}>
                    desde {sep.inicio_ensayo?.slice(5,16)}
                  </div>
                )}
              </div>

              {/* Métricas */}
              {[
                { k:'CAUDAL_GAS',      u:'m³/h', acum:'ACUM_GAS'       },
                { k:'CAUDAL_PETROLEO', u:'m³/d', acum:'ACUM_PETROLEO'  },
                { k:'CAUDAL_AGUA',     u:'m³/d', acum:'ACUM_AGUA'      },
                { k:'PRES_GAS',        u:'bar',  acum: null },
                { k:'TEMP',            u:'°C',   acum: null },
              ].map(m => (
                <div key={m.k} style={{padding:'0 12px', borderRight:'1px solid #e0e0e0'}}>
                  {/* Caudal */}
                  <div style={{display:'flex', alignItems:'baseline', gap:'6px', marginBottom:'2px'}}>
                    <div>
                      <div style={{fontSize:'9px', color:'#a0a0a0', textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:'2px'}}>
                        {m.k.replace('CAUDAL_','').replace('PRES_','')}
                      </div>
                      <div style={{fontSize:'15px', fontWeight:'600', color: activo ? '#1a1a1a' : '#a0a0a0', fontFamily:'monospace'}}>
                        {fmt(datos[m.k])}
                        <span style={{fontSize:'9px', color:'#a0a0a0', marginLeft:'2px'}}>{m.u}</span>
                      </div>
                    </div>
                    {/* Acumulado */}
                    {m.acum && (
                      <div style={{borderLeft:'1px solid #e0e0e0', paddingLeft:'6px'}}>
                        <div style={{fontSize:'9px', color:'#a0a0a0', textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:'2px'}}>
                          Ensayo
                        </div>
                        <div style={{fontSize:'15px', fontWeight:'600', color: activo ? '#6b6b6b' : '#a0a0a0', fontFamily:'monospace'}}>
                          {datos[m.acum] != null ? Math.round(datos[m.acum]).toLocaleString('es-AR') : '—'}
                          <span style={{fontSize:'9px', color:'#a0a0a0', marginLeft:'2px'}}>m³</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}

              {/* Acciones */}
              <div style={{padding:'0 12px', display:'flex', gap:'4px', justifyContent:'flex-end', alignItems:'center'}}>
                {(() => {
                  const ps = paeStatus[sep.id];
                  const enabled = !ps || ps.enabled !== false;
                  return (
                    <button
                      onClick={(e) => { e.stopPropagation(); togglePae(sep.id); }}
                      title={enabled ? 'Detener transmisión a PAE' : `PAE detenido por ${ps?.usuario || '?'}`}
                      style={{
                        padding:'3px 8px', borderRadius:'6px', fontSize:'10px', fontWeight:'600',
                        border: `1px solid ${enabled ? '#16a34a' : '#dc2626'}`,
                        background: enabled ? '#f0fdf4' : '#fef2f2',
                        color: enabled ? '#16a34a' : '#dc2626',
                        cursor:'pointer', whiteSpace:'nowrap',
                        display:'flex', alignItems:'center', gap:'4px'
                      }}><span style={{fontSize:'13px'}}>{enabled ? '🔌' : '⚡'}</span> PAE</button>
                  );
                })()}
                <button
                  onClick={(e) => { e.stopPropagation(); setGrafico({id: sep.id, nombre: sep.nombre}); }}
                  title="Ver gráfico"
                  style={{
                    width:'26px', height:'26px', borderRadius:'6px',
                    border:'1px solid #e0e0e0', background:'transparent',
                    display:'flex', alignItems:'center', justifyContent:'center',
                    cursor:'pointer', color:'#6b6b6b', fontSize:'13px'
                  }}>📈</button>
              </div>
            </div>
          );
        })}
      </div>

      {/* PANEL DETALLE */}
      {selectedSep && <HistorialPanel sep={selectedSep} />}
      {grafico && (
        <GraficoSeparador
          sepId={grafico.id}
          nombre={grafico.nombre}
          onClose={() => setGrafico(null)}
        />
      )}

      <style>{`
        @keyframes blink { 0%,100%{opacity:1} 50%{opacity:0.3} }
        ::-webkit-scrollbar { width: 4px }
        ::-webkit-scrollbar-track { background: transparent }
        ::-webkit-scrollbar-thumb { background: #d0d0d0; border-radius: 2px }
      `}</style>
    </div>
  );
}
